<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Lot Create</h1>
                    </div>
                    <div class="col-sm-6">
                        <img id="logoId" src="../../../public/images/logo.png" style="width:40px; height:40px; display:none;">
                    </div>
                </div>
            </div>
        </div>

        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <!-- Search Section -->
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                                        <div class="form-group">
                                            <label>Status <span class="text-danger">*</span></label>
                                            <v-select
                                                v-model="search.status"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options="lotStatusList"
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div v-if="search.status == 1" class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                                        <div class="form-group">
                                            <label>Source Hub <span class="text-danger">*</span></label>
                                            <v-select
                                                multiple
                                                v-model="search.source_hub_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options="hubList"
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div v-if="search.status == 4" class="col-xl-2 col-lg-2 col-md-2 col-sm-6">
                                        <div class="form-group">
                                            <label>Destination Hub <span class="text-danger">*</span></label>
                                            <v-select
                                                v-model="search.destination_hub_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options="hubList"
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group" style="margin-top:28px;">
                                            <button class="btn btn-info btn-sm mr-2" @click.prevent="searchData"><i class="fa fa-search"></i></button>
                                            <button class="btn btn-warning btn-sm" @click.prevent="reload"><i class="fa fa-sync-alt"></i></button>
                                            <b style="margin-left:10px; font-size:18px">Total: {{ totalParcel }}</b>
                                            <b style="margin-left:10px; font-size:18px">Scanned: {{ form.order_ids.length }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Scanner + Submit -->
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-md-3"></div>
                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                                        <div class="form-group">
                                            <label>Scan or type order id <span class="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="itemId"
                                                @keyup.enter="keepOrder"
                                                placeholder="Scan barcode or type order id and press enter"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6" style="margin-top:30px" v-if="form.order_ids.length > 0">
                                        <button class="btn btn-info btn-sm" @click.prevent="submitData">Submit</button>
                                    </div>
                                    <div class="col-md-3"></div>
                                </div>
                            </div>

                            <!-- Selected Order IDs -->
                            <div class="card-body">
                                <span
                                    v-for="(orderId, index) in form.order_ids"
                                    :key="index"
                                    class="btn btn-sm btn-warning mb-1 mr-1"
                                >
                                    {{ orderId }}
                                    <i class="ml-1 fas fa-times" @click="removeRow(orderId)"></i>
                                </span>
                            </div>

                            <!-- Table -->
                            <div class="card-body">
                                <b-overlay :show="loader">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped table-sm">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <label style="cursor:pointer;" @click="toggleSelectAllFromText">
                                                            <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" />
                                                            Order ID
                                                        </label>
                                                    </th>
                                                    <th>Merchant</th>
                                                    <th>Customer</th>
                                                    <th>Address</th>
                                                    <th>Source to Destination</th>
                                                    <th>Status</th>
                                                    <th>Price</th>
                                                    <th>Order Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in listData" :key="index">
                                                    <td>
                                                        <label>
                                                            <input
                                                                v-model="form.order_ids"
                                                                :value="item.id"
                                                                type="checkbox"
                                                                class="order-checkbox"
                                                            />
                                                            <p class="d-inline" style="cursor:pointer;" @click="toggleSingle(item.id)">
                                                                {{ item.id }}
                                                            </p>
                                                        </label>
                                                    </td>
                                                    <td>{{ item.merchant.business }}</td>
                                                    <td>{{ item.name }}, {{ item.mobile }}</td>
                                                    <td>{{ item.address }}</td>
                                                    <td>
                                                        {{ item.source ? item.source.name : '' }} →
                                                        {{ item.destination ? item.destination.name : '' }}
                                                    </td>
                                                    <td><span :class="'status-'+item.status">{{ getStatus(item.status) }}</span></td>
                                                    <td>{{ item.price }}</td>
                                                    <td>{{ item.date }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import config from '@/config'

export default {
    name: 'LotCreate',
    data() {
        return {
            loader: false,
            selectAll: false,
            listData: [],
            itemId: '',
            totalParcel: 0,
            search: {
                source_hub_id: '',
                destination_hub_id: '',
                status: '',
            },
            form: {
                destination_hub_id: '',
                status: '',
                order_ids: [],
            },
        }
    },
    watch: {
        'form.order_ids'(newVal) {
            this.selectAll = this.listData.length > 0 && newVal.length === this.listData.length
        },
        'search.status'(newVal, oldVal) {
            if (newVal != oldVal && newVal == 1) {
                const currentHub = this.hubList.find(el => el.text?.toLowerCase().includes('central'))
                this.form.destination_hub_id = currentHub ? currentHub.id : ''
            }
        },
        'search.destination_hub_id'(newVal, oldVal) {
            if (newVal != oldVal) {
                this.form.destination_hub_id = newVal
            }
        },
    },
    computed: {
        authUser() {
            return this.$store.state.authUser
        },
        customState() {
            return this.$store.state
        },
        hubList() {
            return this.$store.state.commonObj.hubList
        },
        lotStatusList() {
            return this.$store.state.lotStatusList.filter(el => el.id == 1 || el.id == 4)
        },
    },
    methods: {
        async searchData() {
            this.loadData()
        },
        async loadData() {
            this.totalParcel = 0
            this.form.order_ids = []
            this.selectAll = false
            this.loader = true
            const response = await config.getData('/lot/create', this.search)
            this.loader = false
            if (response.success) {
                this.totalParcel = response.data.length
                this.listData = response.data
            } else {
                this.listData = []
                this.$toast.error({
                    title: 'Error',
                    message: 'Please search with Destination or Source Hub',
                    color: '#dc3545',
                })
            }
        },
        getStatus(status) {
            const tmpStatus = this.customState.statusList.find(tmp => tmp.id == status)
            return tmpStatus ? tmpStatus.text : status
        },
        toggleSelectAll() {
            if (this.selectAll) {
                this.form.order_ids = this.listData.map(item => item.id)
            } else {
                this.form.order_ids = []
            }
        },
        toggleSelectAllFromText() {
            this.selectAll = !this.selectAll
            this.toggleSelectAll()
        },
        toggleSingle(id) {
            const index = this.form.order_ids.indexOf(id)
            if (index > -1) {
                this.form.order_ids.splice(index, 1)
            } else {
                this.form.order_ids.push(id)
            }
        },
        keepOrder() {
            let skuList = this.itemId.split(' ')
            if (skuList.length > 1) {
                skuList.forEach(item => {
                    if (this.listData.find(el => el.id === parseInt(item))) {
                        this.form.order_ids.push(item)
                    }
                })
            } else {
                const tmpItem = this.listData.find(el => el.id === parseInt(this.itemId))
                if (tmpItem) {
                    this.form.order_ids.push(this.itemId)
                    this.listData = this.listData.filter(el => el.id !== parseInt(this.itemId))
                    this.totalParcel -= 1
                } else {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Sorry, parcel not found',
                        color: '#dc3545',
                    })
                }
            }
            this.itemId = ''
        },
        removeRow(id) {
            this.form.order_ids = this.form.order_ids.filter(el => parseInt(el) !== parseInt(id))
        },
        async submitData() {
            this.loader = true
            const formData = Object.assign(this.form, { status: this.search.status })
            const response = await config.postData('/lot/store', formData)
            this.loader = false
            if (response.success) {
                this.form.order_ids = []
                this.loadData()
                this.$toast.success({
                    title: 'Success',
                    message: 'Data submitted successfully',
                    color: '#218838',
                })
            } else {
                this.$toast.error({
                    title: 'Error',
                    message: response.errors
                        ? 'Please select Destination Hub & Status'
                        : 'Something went wrong',
                    color: '#dc3545',
                })
            }
        },
    },
}
</script>
